// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__TisComponents from "./TisComponents.js";
import * as Buhta_landing__TisComponentsMobile from "./TisComponentsMobile.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TisTheoretical(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "«Бухта позволяет нам сократить расходы на бухгалтерию, вместе с тем предоставляя хорошее качество обслуживания.»",
            className: "paragraph-large text-center text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Алена Ткаченко ･ Nommi",
            className: "paragraph-small text-center text-black-landing mt-2 lg:mt-4"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: "h-6",
              src: StaticAsset.src("/static/icons/nommi.svg")
            }),
            className: "flex m-auto mt-6 lg:mt-8 justify-center"
          })
        ],
        className: Cn.fromList({
          hd: deviceType === "mobile" ? "bg-warning" : "bg-secondary",
          tl: {
            hd: "lg:flex lg:m-auto lg:mt-20 py-10 px-6 sm:px-48 lg:py-16 lg:px-20 lg:rounded-sm lg:flex-col lg:w-252",
            tl: /* [] */ 0
          }
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Компоненты системы",
            className: "h4 lg:h3 lg:flex lg:m-auto lg:w-252 text-white"
          }),
          JsxRuntime.jsx("p", {
            children: "ТИС Бухта состоит из следующих модулей:",
            className: "paragraph-large lg:h-light lg:flex lg:mx-auto mt-2 lg:w-252 text-white"
          }),
          deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsx(Buhta_landing__TisComponentsMobile.make, {}) : JsxRuntime.jsx(Buhta_landing__TisComponents.make, {}),
          JsxRuntime.jsx("p", {
            children: "Модули взаимосвязаны и имеют возможность передавать данные из одного модуля в другой.",
            className: "paragraph-small opacity-64 flex m-auto mt-6 lg:mt-20 lg:w-252 text-white"
          })
        ],
        className: "bg-primary-variant lg:mt-20 py-10 px-6 lg:py-40 sm:px-48 lg:px-0"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "«Ведение налогового учета это очень важный момент нашего бизнеса. Бухта - профессионал в этом.»",
            className: "paragraph-large text-center text-black-landing"
          }),
          JsxRuntime.jsx("p", {
            children: "Ерсултан Рамазан ･ Япартнер",
            className: "paragraph-small text-center text-black-landing mt-2 lg:mt-4"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: "h-6",
              alt: "yapartner",
              src: StaticAsset.src("/static/images/yapartner.png")
            }),
            className: "flex m-auto mt-6 justify-center w-25.5"
          })
        ],
        className: "lg:flex lg:m-auto lg:mt-20 py-10 px-6 lg:py-16 sm:px-48 lg:px-20 lg:rounded-sm lg:flex-col lg:w-252 bg-warning"
      }),
      JsxRuntime.jsx("h3", {
        children: "Процедура подключения",
        className: "h3 lg:flex lg:m-auto lg:w-200 pt-10 lg:pt-40 px-6 sm:px-48 lg:px-0 text-black-landing"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: "Сотрудник ТОО “Бухта” получив заявку проводит анализ клиента согласно Закона “О противодействии легализации (отмыванию) доходов, полученных преступным путем, и финансированию терроризма” с целью установления степени добропорядочности клиента. Для этого он запрашивает у клиента все необходимые данные: ИИН, ФИО, данные документа на осуществление предпринимательской деятельности, банковские реквизиты.",
            className: "paragraph lg:w-96 text-gray-landing"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("p", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "mr-2",
                    src: StaticAsset.src("/static/icons/number-one-check.svg")
                  }),
                  JsxRuntime.jsx("span", {
                    children: "Зарегистрироваться на сайте buhta.com",
                    className: "mt-2"
                  })
                ],
                className: "flex paragraph text-black-landing"
              }),
              JsxRuntime.jsxs("p", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "mr-2",
                    src: StaticAsset.src("/static/icons/number-two-check.svg")
                  }),
                  JsxRuntime.jsxs("span", {
                    children: [
                      "Нажать кнопку создать ",
                      JsxRuntime.jsx("strong", {
                        children: "новый тикет",
                        className: "paragraph-medium"
                      })
                    ],
                    className: "mt-2"
                  })
                ],
                className: "flex paragraph text-black-landing mt-2"
              }),
              JsxRuntime.jsxs("p", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "mr-2",
                    src: StaticAsset.src("/static/icons/number-three-check.svg")
                  }),
                  JsxRuntime.jsx("span", {
                    children: "Оставить заявку на подключение",
                    className: "mt-2"
                  })
                ],
                className: "flex paragraph text-black-landing mt-2"
              })
            ],
            className: "mt-8 lg:mt-0 lg:w-96"
          })
        ],
        className: "lg:flex lg:m-auto justify-between p-6 lg:py-20 sm:px-48 lg:px-0 lg:w-200"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("p", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "mr-2",
                    src: StaticAsset.src("/static/icons/number-four-check.svg")
                  }),
                  JsxRuntime.jsx("span", {
                    children: "Подписать договор",
                    className: "mt-2"
                  })
                ],
                className: "flex paragraph text-black-landing"
              }),
              JsxRuntime.jsxs("p", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "mr-2",
                    src: StaticAsset.src("/static/icons/number-five-check.svg")
                  }),
                  JsxRuntime.jsx("span", {
                    children: "Оплатить услугу ТИС",
                    className: "mt-2"
                  })
                ],
                className: "flex paragraph text-black-landing mt-2"
              }),
              JsxRuntime.jsxs("p", {
                children: [
                  JsxRuntime.jsx("img", {
                    className: "mr-2",
                    src: StaticAsset.src("/static/icons/number-six-check.svg")
                  }),
                  JsxRuntime.jsx("span", {
                    children: "Получить доступ",
                    className: "mt-2"
                  })
                ],
                className: "flex paragraph text-black-landing mt-2"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        src: StaticAsset.src("/static/icons/contract-circled.svg")
                      }),
                      JsxRuntime.jsx("p", {
                        children: "Договор",
                        className: "paragraph-small text-black-landing -mt-4"
                      })
                    ],
                    className: "flex flex-col items-center text-center -ml-4 mr-2"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                        src: StaticAsset.src("/static/icons/docs-circled.svg")
                      }),
                      JsxRuntime.jsx("p", {
                        children: "Инструкция по использованию ТИС",
                        className: "paragraph-small text-black-landing -mt-4"
                      })
                    ],
                    className: "flex flex-col items-center text-center w-36"
                  })
                ],
                className: "flex justify-center lg:justify-start mt-8"
              })
            ],
            className: "mt-8 lg:mt-0 lg:w-96"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "После проверки клиента, в случае отсутствия препятствий для подключения ТИС Бухта клиенту, сотрудник компании составляет договор на использование ТИС Бухта.",
                className: "paragraph text-gray-landing"
              }),
              JsxRuntime.jsx("p", {
                children: "После подписания договора клиент производит оплату за использование ТИС Бухта.",
                className: "paragraph text-gray-landing mt-2 lg:mt-4"
              }),
              JsxRuntime.jsx("p", {
                children: "После произведения оплаты, клиент получает доступ к использованию ТИС Бухта и использует его в своей деятельности.",
                className: "paragraph text-gray-landing mt-2 lg:mt-4"
              })
            ],
            className: "lg:w-96"
          })
        ],
        className: "flex m-auto flex-col-reverse lg:flex-row px-6 sm:px-48 lg:px-0 lg:justify-between lg:w-200"
      })
    ]
  });
}

const make = TisTheoretical;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
